import { Component, OnInit } from '@angular/core';
import { MenuHomeEnum } from 'app/home';
import { ConfigService, MerchantService } from 'app/services';
import { Utils } from 'app/utils';
import { MessageService } from 'primeng/api';
import { TableLazyLoadEvent } from 'primeng/table';
import { MerchantTypeEnum } from '../../../models/enums/lokal/merchant-type.enum';
import { MartOnboardingDto } from '../../home/partners/mart-onboarding/interfaces/mart-onboarding-dto';

@Component({
    selector: 'mart-merchants',
    templateUrl: './mart-merchants.component.html',
    styleUrls: ['./mart-merchants.component.scss',
        '../../../../styles/sidebar.scss'
    ],
    providers: [MessageService]
})
export class MartMerchantsComponent implements OnInit {

    constructor(private messageService: MessageService,
        private merchantService: MerchantService,
        public configService: ConfigService) {
    }

    public merchants: Array<any> = [];

    public cols: any[] = [
        { field: 'Id', header: 'Partner ID', width: '90px' },
        { field: 'PartnerName', header: 'Partner Name' },
        { field: 'XpressAgent', header: 'Xpress Agent' },
        { field: 'CreatedAt', header: 'Created', width: '200px' },
        { field: 'ExpiryAt', header: 'Expiry', width: '200px' },
        { field: 'StatusText', header: 'Status', width: '200px' },
        { field: 'LastActive', header: 'Last Active', width: '200px' }
    ];

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public filter: {
        searchName: string;
    } = { searchName: '' };

    public loading: boolean = true;

    private searchTimer: number = 0;

    //------------Detail mart merchant sidebar---------------------
    public showMartDetailMerchantSideBar: boolean = false;
    public merchantId: number = 0;
    //------------End---------------------------------------------

    ngOnInit(): void {
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getMerchants(skip);
    }

    public getMerchants(skip: number): void {
        this.loading = true;

        const dto: MartOnboardingDto = {
            SearchName: this.filter.searchName,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            MerchantType: MerchantTypeEnum.Marts,
            IsAllPartners: true
        };

        this.merchantService.getMerchants(dto, MenuHomeEnum.MartOnboarding, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.merchants = data.Items;

                this.merchants.forEach(item => {
                    item.CreatedAt = Utils.utcToLocaleString(item.CreatedAt);
                    item.ExpiryAt = Utils.utcToLocaleString(item.ExpiryAt);
                });

                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getMerchants(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public openMartDetailMerchantSideBar(merchant: any) {
        this.merchantId = merchant.Id;
        this.showMartDetailMerchantSideBar = !this.showMartDetailMerchantSideBar;
    }

    changedShowMartDetailMerchantSideBarEmit(value: any) {
        this.showMartDetailMerchantSideBar = value;
    }
}
